"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Config_1 = require("../Config/Config");
const FetchProxy_1 = require("../Utility/FetchProxy");
class User {
    constructor(data) {
        this._data = data;
        this._id = data.id;
    }
    get id() {
        return this._id;
    }
    get data() {
        return this._data;
    }
    async update(data) {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user/update?userId=${this._id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            }).auth().fetch();
            const newData = await res.json();
            this._data = newData;
            return this;
        }
        catch (err) {
            throw new Error(`Update user fail: status ${err.message}`);
        }
    }
    async updatePassword(newPass, oldPass) {
        try {
            await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user/update_password`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    newPass: newPass,
                    oldPass: oldPass
                })
            }).auth().fetch();
        }
        catch (err) {
            throw new Error(`Update user password fail: status ${err.message}`);
        }
    }
    async resetPassword(pass) {
        try {
            await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user/reset_password?userId=${this._id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    pass: pass
                })
            }).auth().fetch();
        }
        catch (err) {
            throw new Error(`Failed to reset user password: status ${err.message}`);
        }
    }
    async updateHeadshot(file) {
        try {
            const formData = new window.FormData();
            formData.append('image', file);
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user_image/headshot/upload?userId=${this._id}`, {
                method: 'POST',
                body: formData
            }).auth().fetch();
            this._data.headShotPath = await res.text();
        }
        catch (err) {
            throw new Error(`Update user headshot fail: status ${err.message}`);
        }
    }
    async resetHeadshot() {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user_image/headshot/reset?userId=${this._id}`, {
                method: 'PUT'
            }).auth().fetch();
            this._data.headShotPath = await res.text();
        }
        catch (err) {
            throw new Error(`Update user headshot fail: status ${err.message}`);
        }
    }
    async licenseUpload(file, pictureDesc) {
        try {
            const formData = new window.FormData();
            formData.append('image', file);
            formData.append('pictureDesc', pictureDesc);
            const result = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user_image/license/upload?userId=${this._id}`, {
                method: 'POST',
                body: formData
            }).auth().fetch();
            return await result.text();
        }
        catch (err) {
            throw new Error(`Upload user license image fail: status ${err.message}`);
        }
    }
    async licenseDelete(imageId) {
        try {
            await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user_image/license/delete?imageId=${imageId}`, {
                method: 'DELETE'
            }).auth().fetch();
        }
        catch (err) {
            throw new Error(`Delete user license image fail: status ${err.message}`);
        }
    }
    async licenseUpdate(imageId, pictureDesc) {
        try {
            await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user_image/license/update?imageId=${imageId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ pictureDesc: pictureDesc })
            }).auth().fetch();
        }
        catch (err) {
            throw new Error(`Update user license image fail: status ${err.message}`);
        }
    }
}
exports.default = User;
//# sourceMappingURL=User.js.map